<!--
 * @Author: GeekMzy
 * @Date: 2023-02-15 14:52:04
 * @FilePath: \htwlgs-drainage-webv2-shiju\src\components\Dialog\modelDialog.vue
-->
<template>
  <div class="content">
    <iframe
      class="mainFrame"
      name="mainFrame"
      src="https://yclyjk.cqhtwl.com.cn/modelweb/?ChannelNumber=0E7D6F068035DEAB5E68B6D122D9939B"
      target="_blank"
      frameborder="0"
      width="1700"
      height="900"
    ></iframe>
    <!-- <iframe
      class="mainFrame"
      name="mainFrame"
      src="https://yclyjk.cqhtwl.com.cn/modelweb/"
      target="_blank"
      frameborder="0"
      width="1700"
      height="900"
    ></iframe> -->
  </div>
</template>

<script setup>
import { nextTick, markRaw } from 'vue'
import { ref } from 'vue-demi'
const dialogVisible = ref(false)
const open = () => {
  dialogVisible.value = true
}
const close = () => {
  dialogVisible.value = false
}
const afterLeave = () => {
  changeTab('')
  modal = ''
  data.value = {}
  Bus.emit('onClose')
}
defineExpose({
  close,
  open,
})
</script>

<style lang="scss" scoped>
.my-dialog {
  width: 1920px;
  height: 1080px;
}
</style>
